<template>
  <v-card v-if="documents.length > 0" class="pa-md-5 mt-3">
    <v-card-subtitle>
      {{ documents.length }} matching document(s)
    </v-card-subtitle>
    <v-list three-line>
      <v-list-item
        v-for="(item, index) in documents"
        :key="index"
        class="mb-2"
        @click="resultClicked(item)"
      >
        <v-img
          :src="getImage(item)"
          class="mr-3"
          contain
          max-height="120"
          max-width="100"
        >
          <template v-slot:placeholder>
            <v-layout fill-height align-center justify-center>
              <v-progress-circular indeterminate color="primary">
              </v-progress-circular>
            </v-layout>
          </template>
        </v-img>
        <v-list-item-content>
          <v-list-item-title class="mb-3">
            {{ item.title }}
          </v-list-item-title>
          <v-list-item-subtitle>
            <v-row class="ml-0">
              <v-col cols="12" md="2" class="pt-0 pb-1 pl-0">
                <strong>Brands:</strong>
              </v-col>
              <v-col cols="12" md="10" class="pt-0 pb-1 pl-0">
                {{ item.brand.map(b => b.brandDescription).join(', ') }}
              </v-col>
            </v-row>
            <v-row class="ml-0">
              <v-col cols="12" md="2" class="pt-0 pb-1 pl-0">
                <strong>Languages:</strong>
              </v-col>
              <v-col cols="12" md="10" class="pt-0 pb-1 pl-0">
                {{
                  item.translationDocuments
                    .map(x => x.languageNavigation.description)
                    .join(', ')
                }}
              </v-col>
            </v-row>
            <v-row class="ml-0">
              <v-col cols="12" md="2" class="pt-0 pb-1 pl-0">
                <strong>Document #: </strong>
              </v-col>
              <v-col cols="12" md="10" class="pt-0 pb-1 pl-0">
                {{ item.mci }}
              </v-col>
            </v-row>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import router from '../router';

export default {
  computed: {
    ...mapState('documents', ['documents', 'isLoading']),
    ...mapState('brands', ['brands']),
    ...mapState('languages', ['languages', 'searchLanguageValue'])
  },
  methods: {
    ...mapMutations('snackbar', ['showSnackbar']),
    resultClicked(doc) {
      let lang;
      if (!this.searchLanguageValue) {
        if (doc.translationDocuments.some(x => x.language == 'en')) {
          lang = 'en';
        } else {
          lang = doc.translationDocuments[0].language;
        }
      } else {
        lang = this.searchLanguageValue;
      }
      router.push({
        name: 'documentDetails',
        params: { id: doc.id, language: lang }
      });
    },
    getImage(doc) {
      let fileName = doc.translationDocuments[0].fileName;
      fileName = fileName.substr(0, fileName.lastIndexOf('.')) + '.jpg';
      return process.env.VUE_APP_API_SERVER + '/Image/' + fileName;
    }
  }
};
</script>

<style scoped>
.pdfPreview {
  max-width: 6.5em;
  max-height: 8em;
  overflow: hidden;
}
</style>
